import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache:true
};
const noCacheMeta = {
    auth: false
};

export default {
    path: '/bpm/my',
    name: 'userOffice',
    redirect: {
        name: 'todoTaskList'
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: '/bpm/my/todoTaskList',
            name: 'todoTaskList',
            meta: {
                auth: false,
    			cache: true,
                title: '$t:menu.TODOTaskList',
                desc:'待办事项',
            },
            component: () => import('@/pages/bpm/my/todoTaskList.vue')
        },
        {
            path: '/bpm/my/approveHistoryList',
            name: 'approveHistoryList',
            meta: {
                ...meta,
                title: '$t:menu.approveHistoryList',
                desc:'办理历史',
            },
            component: () => import('@/pages/bpm/my/approveHistoryList.vue')
        },
        {
            path: '/bpm/my/xxlb',
            name: 'xxlb',
            meta: {
                ...meta,
                title: '$t:menu.xxlb',
                desc:'消息列表',
            },
            component: () => import('@/pages/bpm/my/xxlb.vue')
        },
        {
            path: '/bpm/my/draft',
            name: 'myDraft',
            meta: {
                ...meta,
                title: '$t:menu.mydraft',
                desc:'我的草稿',
            },
            component: () => import('@/pages/bpm/my/draftList.vue')
        },
        {
            path: '/bpm/my/startFlow',
            name: 'startFlow',
            meta: {
                ...meta,
                title: '$t:menu.shishangshenqing',
                desc:'发起申请',
            },
            component:title=> import('@/pages/bpm/my/startFlowList.vue')
        },
        {
            path: '/bpm/my/applyHistory',
            name: 'applyHistoryList',
            meta: {
                auth: false,
    			cache: true,
                title: '$t:menu.applyHistory',
                desc:'申请历史',
            },
            component: () => import('@/pages/bpm/my/applyHistoryList.vue')
        },
        {
            path: '/bpm/instance/instanceDetail/:id',
            name: 'instanceDetail',
            meta: {
                auth: false,
    			cache: false,
                title: '$t:menu.instanceDetail',
                desc:'流程详情',
            },
            component: () => import('@/pages/bpm/instance/instanceDetail.vue')
        },
        {
            path: '/bpm/instance/start/:flowKey',
            name: 'definitionStart',
            meta: {
                ...meta,
                title: '$t:menu.start',
                desc:'发起流程',
            },
            component: () => import('@/pages/bpm/instance/start.vue')
        },
        {
            path: '/bpm/instance/taskComplete/:id',
            name: 'taskComplete',
            meta: {
                ...meta,
                title: '$t:menu.taskComplete',
                desc:'处理任务',
            },
            component: () => import('@/pages/bpm/instance/taskComplete.vue')
        },
        {
            path: '/bpm/flowImage/:defId/:instId/:taskId',
            name: 'flowImage',
            meta: {
                ...meta,
                title: '$t:page.task.flowImage',
            },
            component: () => import('@/components/ab-bpm/buttonDialogs/bpm-flow-image-dialog.vue')
        },
        {
            path: '/bpm/instance/draftStart/:id',
            name: 'draftStart',
            meta: {
                ...meta,
                title: '$t:menu.draftStart',
                desc:'启动草稿',
            },
            component: () => import('@/pages/bpm/instance/draftStart.vue')
        },
        {
            path: '/form/form/preview',
            name: 'form_preview',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.formPreview',
                desc:'表单预览',
                hideInMenu: true
            },
            component: () => import('@/pages/bpm/form/preview.vue')
        },
        {
            path: '/form/form/preview',
            name: 'form_preview',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.formPreview',
                hideInMenu: true
            },
            component: () => import('@/pages/bpm/form/preview.vue')
        },
        {
            path: '/form/formCustSql/view/formCustSqlView.html',//为了跟设计平台的地址一致
            name: 'formCustSqlView',
            meta: {
                ...noCacheMeta,
                title:'',
                desc:'',
                hideInMenu: true
            },
            component: () => import('@/pages/bpm/custsql/formCustSqlView.vue')
        },
        {
            path: '/form/formCustSql/view/nauticalChart.html',
            name: 'nauticalChart',
            meta: {
                ...noCacheMeta,
                title:'海图',
                desc:'海图',
                hideInMenu: true
            },
            component: () => import('@/pages/bpm/nauticalChart/index.vue')
        },
        {
            path: '/form/formCustSql/view/heatMap.html',
            name: 'heatMap',
            meta: {
                ...noCacheMeta,
                title:'热力图',
                desc:'热力图',
                hideInMenu: true
            },
            component: () => import('@/pages/bpm/heatMap/index.vue')
        },
		{
            path: '/form/custDashboard/formCustDashboardView.html',//为了跟设计平台的地址一致
            name: 'formCustDashboardView',
            meta: {
                ...noCacheMeta,
                title:'自定义仪表盘',
                hideInMenu: true
            },
            component: () => import('@/pages/bpm/custdashboard/formCustDashboardView.vue')
        },
        {
            path: '/bpm/my/myDefinitionList',
            name: 'myDefinitionList',
            meta: {
                ...meta,
                title: '$t:menu.startFlow',
                desc:'发起申请',
            },
            component: () => import('@/pages/bpm/my/myDefinitionList.vue')
        },
        {
            path: '/bpm/my/carboncopyReceiveList',
            name: 'carboncopyReceiveList',
            meta: {
            	...meta,
                title: '$t:menu.carboncopyReceive',
                desc:'我的抄送',
            },
            component: () => import('@/pages/bpm/my/carboncopyReceiveList.vue')
        },
        {
            path: '/bpm/plugin/userAgencyConfigList',
            name: 'userAgencyConfigList',
            meta: {
            	...meta,
                title: '$t:menu.userAgencyConfig',
				desc: '流程代理',
            },
            component: () => import('@/pages/bpm/bpmplugin/userAgencyConfigList.vue')
        },
        {
            path: '/bpm/my/bpm/plugin/userAgencyConfigEdit',
            name: 'userAgencyConfigEdit',
            meta: {
            	...meta,
                title: '$t:menu.userAgencyEdit',
				desc: '代理编辑',
            },
            component: () => import('@/pages/bpm/bpmplugin/userAgencyConfigEdit.vue')
        },
        {
            path: '/bpm/my/bpm/plugin/userAgencyLogList/:id',
            name: 'userAgencyLogList',
            meta: {
            	...noCacheMeta,
                title: '$t:menu.userAgencyConfig',
				desc: '代理配置',
            },
            component: () => import('@/pages/bpm/bpmplugin/userAgencyLogList.vue')
        },
        {
            path: '/demo/DemoList',
            name: 'DemoList',
            meta: {
            	...noCacheMeta,
                title: 'DEMO页面',
            },
            component: () => import('@/pages/demo/DemoList.vue')
        },
        {
            path: '/my/dailyPhrasesList',
            name: 'dailyPhrasesList',
            meta: {
                ...noCacheMeta,
                title:'$t:menu.dailyPhrases',
                desc: '用户常用语',
            },
            component: () => import('@/pages/bpm/my/dailyPhrasesList')
        },
        {
            path: '/my/dailyPhrasesEdit',
            name: 'dailyPhrases_add',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.addPhrases',
                desc: '新增常用语'
            },
            component: () => import('@/pages/bpm/my/dailyPhrasesEdit')
        }
    ]
};
